import styled from 'styled-components';
import { Body2, Caption, colors, spacing } from 'ui/theme';
import { Cell } from './Table.styled';

const ProjectName = styled(Body2)`
  margin-bottom: ${spacing.quarter};
`;

const ProjectId = styled(Caption)`
  color: ${colors.textSecondary};
`;

type ProjectCellProps = {
  projectName: string;
  projectId: number;
};

export const ProjectCell = ({ projectName, projectId }: ProjectCellProps) => {
  return (
    <Cell flexDirection="column" alignItems="flex-start" gap="0">
      <ProjectName>{projectName}</ProjectName>
      <ProjectId>ID: {projectId}</ProjectId>
    </Cell>
  );
};
